import BuildIcon from "@mui/icons-material/Build";

import { RobotoTypography } from "@/shared/components/RobotoTypography";
import { AgentThreadToolResultContent } from "@/shared/domain/agentThread/AgentThreadRecord";

import styles from "./AssistantToolResultContent.module.css";

const MS_TO_SECONDS_THRESHOLD = 100;

interface AssistantToolResultContentProps {
  toolResult: AgentThreadToolResultContent;
}

const AssistantToolResultContent = ({
  toolResult,
}: AssistantToolResultContentProps) => {
  const formattedTime =
    toolResult.runtime_ms < MS_TO_SECONDS_THRESHOLD
      ? `${toolResult.runtime_ms}ms`
      : `${(toolResult.runtime_ms / 1000).toFixed(2)}s`;

  return (
    <div className={styles.indentedContainer}>
      <div className={styles.messageContainer}>
        <BuildIcon className={styles.buildIcon} />
        <RobotoTypography className={styles.text}>
          Used Tool <b>{toolResult.tool_name}</b> ({formattedTime})
        </RobotoTypography>
      </div>
    </div>
  );
};

export { AssistantToolResultContent };
